'use client';

import {OnePaneLayoutContainer} from '@udemy-v2/react-layout-components';
import styles from '@/features/organization-team-plan/organization-signup-text.module.scss';
import {Panel} from '@udemy-v2/react-structure-components';
import {BlockList} from '@udemy-v2/react-core-components';
import {Icon} from '@udemy-v2/icons';
import {useFormatNumber, useI18n} from '@udemy-v2/i18n';

const APPROX_COURSE_COUNT = 28000;

interface OrganizationSignupTextProps {
    buyNow: boolean;
}

export function OrganizationSignupText({buyNow}: OrganizationSignupTextProps) {
    const {gettext, interpolate} = useI18n();
    const {formatNumber} = useFormatNumber();

    const description = buyNow
        ? gettext('Sign up to get ready-to-go learning')
        : gettext('Simply create an account to get started');

    return (
        <OnePaneLayoutContainer className={styles.container}>
            <p className={styles.description}>{description}</p>
            <Panel border={false} className={styles.panel}>
                <BlockList size="small">
                    <BlockList.Item
                        key={1}
                        icon={<Icon glyph="merchandise-course" label={false} />}
                    >
                        {interpolate(
                            gettext(
                                'Upskill your workforce with %(courses)s courses, certification prep and custom learning paths',
                            ),
                            {courses: `${formatNumber(APPROX_COURSE_COUNT)}+`},
                            true,
                        )}
                    </BlockList.Item>
                    <BlockList.Item key={2} icon={<Icon glyph="sparkles" label={false} />}>
                        {gettext(
                            "Provide practice with AI Role Plays, in-course practice tests, coding exercises, and more, so they're ready for the real thing.",
                        )}
                    </BlockList.Item>
                    <BlockList.Item key={3} icon={<Icon glyph="data-insight" label={false} />}>
                        {gettext(
                            'Understand and advance skills proficiency with assessments, and track progress with dashboards.',
                        )}
                    </BlockList.Item>
                </BlockList>
            </Panel>
        </OnePaneLayoutContainer>
    );
}
